import url from './url';



export default url(() => '/static-content-reset-logs');
